import { Store } from 'vuex';
import { IVisaSubtype } from '@/shared/model/travelpurpose/visa-subtype.model';

export default class TlsStoreService {
  private store: Store<{}>;

  constructor(store: Store<{}>) {
    this.store = store;
  }

  public getIssuer(): string {
    return this.store.getters.issuer;
  }

  public setIssuer(issuer: String): void {
    this.store.commit('issuer', issuer);
    return this.store.getters.issuer;
  }

  public getVisa(): IVisaSubtype {
    return this.store.getters.visa;
  }

  public setVisa(visa: IVisaSubtype): void {
    this.store.commit('visa', visa);
  }
}
